import { useTranslation } from 'react-i18next'

import Grid from '@mui/material/Grid'

import TextField from '@/components/formik/fields/TextField'
import CheckboxField from '@/components/formik/fields/CheckboxField'

export default function WizardBasicsStep() {
  const { t } = useTranslation()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={8}>
        <TextField fullWidth label={t('field.name.label')} name="name" id="name" />
      </Grid>
      <Grid item xs={12}>
        <TextField fullWidth label={t('field.description.label')} multiline name="description" id="description" rows={3} />
      </Grid>
      <Grid item xs={12}>
        <CheckboxField label={t('field.busyEnabled.label')} name="busyEnabled" />
      </Grid>
    </Grid>
  )
}
